import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import ToastPopup from "../popups/ToastPopup";
import { Review, IStatusEnum, createToastMessage, ToastMessage } from '../interFaces/interfaces';
const columns = [{ label: "Project ID", key: "projectId" }, { label: "Project Name", key: "projectName" }, { label: "Campaign Name", key: "campaignName" }, { label: "Item Status", key: "itemStatus" }, { label: "Remark By QC", key: "remarkByQC" }, { label: "Account ID", key: "accountId" }, { label: "Account Name", key: "accountName" }, { label: "Business Unit", key: "businessUnit" }, { label: "Project Manager Name", key: "projectManagerName" }, { label: "Delivery Manager Name", key: "deliveryManagerName" }, { label: "Delivery Head Name", key: "deliveryHeadName" }, { label: "Team Size", key: "teamSize" }, { label: "Delivery Model", key: "deliveryModel" }, { label: "Billing Type", key: "billingType" }, { label: "Quality Consultant Name", key: "qualityConsultantName" }, { label: "Quality Manager Name", key: "qualityManagerName" }, { label: "Estimation Model", key: "estimationModel" }, { label: "DevOps CI/CD Tool", key: "devOps_CICDtoolname" }, { label: "Testing Tool Name", key: "testingToolName" }, { label: "Code Quality Tool Name", key: "codequalityToolName" }, { label: "Test Manager", key: "testManager" }, { label: "Architect", key: "architect" }, { label: "Technical Lead", key: "technicalLead" }, { label: "Customer Location", key: "customerLocation" }, { label: "Project Location", key: "projectLocation" }, { label: "Project Life Cycle", key: "projectLifeCycle" }, { label: "Project Start Date", key: "projectStartDate" }, { label: "Project End Date", key: "projectEndDate" }, { label: "Created Date", key: "createdDate" }, { label: "Project Manager Email", key: "projectManagerEmail" }, { label: "Delivery Manager Email", key: "deliveryManagerEmail" }, { label: "Delivery Head Email", key: "deliveryHeadEmail" }, { label: "Quality Consultant Email", key: "qualityConsultantEmail" }, { label: "Quality Manager Email", key: "qualityManagerEmail" }, { label: "Test Manager Email", key: "testManagerEmail" }, { label: "Technical Lead Email", key: "technicalLeadEmail" }];
type TabType = "INCLUDED" | "EXCLUDED";
const AdminReview: React.FC = () => {
  const [projects, setProjects] = useState<Review[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [comments, setComments] = useState("");
  const [actionType, setActionType] = useState<"INCLUDE" | "EXCLUDE">("INCLUDE");
  const [activeTab, setActiveTab] = useState<TabType>("INCLUDED");
  const [statusEnums, setStatusEnums] = useState<IStatusEnum[]>([]);
  const location = useLocation();
  const campaignId = location.state?.campaignId;
  const [counts, setCounts] = useState({ included: 0, excluded: 0 });
  const clientId = localStorage.getItem("clientId");
  const email = localStorage.getItem("email");
  const restrictedChars = /[\\:*?"<>|/]/;
  useEffect(() => {
    const fetchStatusEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/ItemStatusEnum");
        setStatusEnums(response);
      } catch (error) {
        console.error("Error fetching status enums:", error);
      }
    };
    fetchStatusEnums();
  }, []);
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const statusFilter = activeTab === "INCLUDED" ? { field: "status", operator: "=", value: "INCLUDED" } : { field: "status", operator: "=", value: "EXCLUDED" };
        const requestBody = [{ field: "campaignId", operator: "=", value: campaignId }, { field: "clientId", operator: "=", value: clientId }, { field: "itemStatus", operator: "=", value: "ADMIN_REVIEW" }, statusFilter];
        const response = await apiCall("post", `/api/campaign-projects/search?page=${currentPage - 1}&size=${itemsPerPage}`, requestBody);
        setProjects(response?.content || []);
        setTotalElements(response?.totalElements || 0);
        setTotalPages(response.totalPages || 0);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setProjects([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [campaignId, currentPage, itemsPerPage, activeTab, clientId]);
  useEffect(() => {
    const fetchAdminReviewCount = async () => {
      try {
        const requestBody = [{ field: "campaignId", operator: "=", value: campaignId }, { field: "itemStatus", operator: "=", value: "ADMIN_REVIEW" }, { field: "clientId", operator: "=", value: clientId }];
        const response = await apiCall("post", `/api/campaign-projects/search?page=0&size=2147483647`, requestBody);
        const includedCount = response?.content?.filter((project: Review) => project.status === "INCLUDED").length || 0;
        const excludedCount = response?.content?.filter((project: Review) => project.status === "EXCLUDED").length || 0;
        setCounts({ included: includedCount, excluded: excludedCount });
      } catch (error) {
        console.error("Error fetching admin review count:", error);
      }
    };
    fetchAdminReviewCount();
  }, [campaignId, clientId]);
  useEffect(() => { setSelectedProjects([]); setSelectAll(false) }, [activeTab]);
  useEffect(() => {
    setSelectAll(projects.length > 0 && projects.every((project) => selectedProjects.includes(project.projectId)));
  }, [projects, selectedProjects]);
  const handleCheckboxChange = (projectId: string) => {
    setSelectedProjects((prevSelected) =>
      prevSelected.includes(projectId) ? prevSelected.filter((id) => id !== projectId) : [...prevSelected, projectId]
    );
  };
  const handleSelectAllChange = () => {
    if (!selectAll) {
      setSelectedProjects(projects.map((project) => project.projectId));
    } else {
      setSelectedProjects([]);
    }
    setSelectAll(!selectAll);
  };
  const handleIncludeClick = () => {
    if (selectedProjects.length === 0) {
      setMessage(createToastMessage("Please select at least one project.", "warning", 3000));
      return;
    }
    setActionType("INCLUDE");
    setShowCommentPopup(true);
  };
  const handleExcludeClick = () => {
    if (selectedProjects.length === 0) {
      setMessage(createToastMessage("Please select at least one project.", "warning", 3000));
      return;
    }
    setActionType("EXCLUDE");
    setShowCommentPopup(true);
  };
  const handleStatusUpdate = async () => {
    try {
      if (!comments.trim()) {
        setMessage(createToastMessage("Please provide a comment for this action", "warning", 3000));
        return;
      }
      const itemStatus = actionType === "INCLUDE" ? "FINAL_INCLUDED" : "FINAL_EXCLUDED";
      await apiCall("patch", `/api/campaign-projects/status/${campaignId}`, { projectIds: selectedProjects, itemStatus, remark: comments, updatedBy: email });
      setMessage(createToastMessage(`Projects ${actionType === "INCLUDE" ? "included" : "excluded"} successfully!`, "success", 3000));
      setShowCommentPopup(false);
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      setMessage(createToastMessage(errorMessage || "An error occurred", "error", 3000));
      setShowCommentPopup(false);
    }
  };
  const formatDate = (dateString?: string): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "" : date.toLocaleDateString();
  };
  const getStatusDescription = (value: string): string => {
    const status = statusEnums.find((enumItem) => enumItem.value === value);
    return status ? status.description : value;
  };
  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (restrictedChars.test(value)) {
      setMessage(createToastMessage(`Special characters are not allowed - ${restrictedChars}`, "warning", 3000));
      return;
    }
    setComments(value);
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Admin Review</h2>
        <div className="table-title-actions">
          {activeTab === "INCLUDED" && (
            <button className="include-button" onClick={handleIncludeClick}>Include Selected</button>
          )}
          {activeTab === "EXCLUDED" && (
            <button className="exclude-button" onClick={handleExcludeClick}>Exclude Selected</button>
          )}
        </div>
      </div>
      <div className="tabs-container">
        <button className={`tab-button ${activeTab === "INCLUDED" ? "active" : ""}`} onClick={() => setActiveTab("INCLUDED")} > Included Projects
          {counts.included > 0 && (
            <span className="notification-badge">{counts.included}</span>
          )}
        </button>
        <button className={`tab-button ${activeTab === "EXCLUDED" ? "active" : ""}`} onClick={() => setActiveTab("EXCLUDED")}> Excluded Projects
          {counts.excluded > 0 && (
            <span className="notification-badge">{counts.excluded}</span>
          )}
        </button>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" checked={selectAll} onChange={handleSelectAllChange} />
                </th>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={columns.length + 1} className="no-data">Loading...</td>
                </tr>
              ) : projects.length > 0 ? (
                projects.map((project) => (
                  <tr key={project.projectId}>
                    <td>
                      <input type="checkbox" checked={selectedProjects.includes(project.projectId)} onChange={() => handleCheckboxChange(project.projectId)} />
                    </td>
                    {columns.map((column) => (
                      <td key={`${project.projectId}-${column.key}`}>
                        {column.key.includes('Date') ? formatDate(project[column.key as keyof Review] as string) : column.key === 'itemStatus' ? getStatusDescription(project[column.key as keyof Review] as string) : project[column.key as keyof Review] || "N/A"}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length + 1} className="no-data">
                    {activeTab === "INCLUDED" ? "There are no included projects." : "There are no excluded projects."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {showCommentPopup && (
        <div className="review-overlay">
          <div className="review-content">
            <h3>{actionType === "INCLUDE" ? "Include" : "Exclude"} Projects</h3>
            <p>Please provide comments for{" "}{actionType === "INCLUDE" ? "including" : "excluding"} these projects:</p>
            <textarea value={comments} onChange={handleCommentChange} placeholder="Enter your comments here..." rows={5} />
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setShowCommentPopup(false)}>Cancel</button>
              <button className="savebutton" onClick={handleStatusUpdate}>Submit</button>
            </div>
          </div>
        </div>
      )}
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default AdminReview;